"use client";

import Carousel from "../Carousel";
import TestimonialsCard from "./TestimonialsCard";
import { useEffect, useState } from "react";
import { formatDistanceToNow } from "date-fns";
import { es } from "date-fns/locale";

interface Review {
  user: {
    name: string;
    thumbnail: string;
  };
  rating: number;
  snippet: string;
  iso_date: string;
}

function Testimonials() {
  const [scrollAmount, setScrollAmount] = useState(300);
  const [reviews, setReviews] = useState<Review[]>([]);
  const [rating, setRating] = useState<number | null>(null);
  const [totalRatings, setTotalRatings] = useState<number | null>(null);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await fetch("/api/reviews-cache");
        const data = await response.json();

        if (data.reviews) {
          const formatted = data.reviews
            .sort((a: any, b: any) => new Date(b.iso_date).getTime() - new Date(a.iso_date).getTime())
            .map((r: any) => ({
              user: r.user,
              rating: r.rating,
              snippet: r.snippet,
              iso_date: r.iso_date
            }));

          setReviews(formatted);
          setRating(data.rating);
          setTotalRatings(data.user_ratings_total);
        }
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };

    fetchReviews();
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setScrollAmount(window.innerWidth * 0.3);
    }
  }, []);

  return (
    <Carousel
      title={`Google Reseñas - ${rating ?? "-"} ⭐ (${totalRatings ?? 0} reseñas)`}
      ariaLabel="Sección de testimonios de nuestros anfitriones"
      scrollAmount={scrollAmount}
    >
      {reviews.length > 0 ? (
        reviews.map((review, index) => (
          <TestimonialsCard
            key={index}
            userName={review.user.name}
            photo={review.user.thumbnail}
            review={review.snippet}
            relative_date={formatDistanceToNow(new Date(review.iso_date), {
              addSuffix: true,
              locale: es,
            })}
            rating={review.rating}
          />
        ))
      ) : (
        <p className="text-center col-span-3">No hay reseñas disponibles.</p>
      )}
    </Carousel>
  );
}

export default Testimonials;